module.exports = __webpack_public_path__ + "img/7.daae8c98.png";